export const gameInfo = 
[
    {
        title :'Tame The Beast',
        preview_pic : "./TameTheBeastPics/ScreenShot1.png",
        info: "Evil Organization Dark Superiors are returning to the world of Beast Tamers (Tame The Beast). Its You who can save the world. Because if Dark Superiors succeed. They will Destroy the world with their cruelty....Catch and train your Beasts teach them new attack moves power up them with help of Crafting. Teach them Super Attack Moves call Ultimate Earn Medals by defeating Arenas and fight for the title for "+
        "''No.1 Beast Tamer In The World'' ",
        allGamePics : ["./TameTheBeastPics/ScreenShot1.png",
                        "./TameTheBeastPics/ScreenShot2.png",
                        "./TameTheBeastPics/ScreenShot3.png",
                        "./TameTheBeastPics/ScreenShot4.png",    
                        "./TameTheBeastPics/ScreenShot5.png",
                        "./TameTheBeastPics/ScreenShot6.png"
                      ],  
        allVideoLinks :["https://www.youtube.com/embed/zOJ01877X2s",
                        "https://www.youtube.com/embed/ofEv8XhGnM0",
                        "https://www.youtube.com/embed/H9esZAWrFiE",
                        "https://www.youtube.com/embed/p11H15K5n8k",    
                       ],
        
        gamePageLink : "/tameTheBeast",
        dowloadLink : "https://play.google.com/store/apps/details?id=com.EkOnkarGames.BeastTamers"


    },

    {
        title :'Devil Knight',
        preview_pic : './DevilKnight_Pics/5.png',
        info : "Enjoy Endless Bullet Gun Adventure With Procedural Generated Maps, With Different Guns and Epic Boss Battles And See How Long You Can Survive In This Pure Action Run And Gun Shooter Game.",
        allGamePics : [
            "./DevilKnight_Pics/1.png",
            "./DevilKnight_Pics/2.png",
            "./DevilKnight_Pics/3.png",
            "./DevilKnight_Pics/4.png",
            "./DevilKnight_Pics/5.png",
            "./DevilKnight_Pics/6.png"
        ],
        allVideoLinks :["https://www.youtube.com/embed/V44sGhtSEFg"],


        gamePageLink : "/devilknight",
        dowloadLink : "https://play.google.com/store/apps/details?id=com.EkonkarGames.DevilKnight"

    }

]